/**
 * Auto Theme Detection Utility
 * Detects system color scheme preference on first login
 */

/**
 * Detects system color scheme preference
 * @returns {string} 'dark' or 'light'
 */
export const detectSystemTheme = () => {
  // Check if browser supports prefers-color-scheme
  if (window.matchMedia) {
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)')
    return darkModeQuery.matches ? 'dark' : 'light'
  }
  // Fallback for browsers without matchMedia support
  return 'light'
}
